import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const readSession = () => {
  try {
    const saved = localStorage.getItem("stagelink-user");
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

api.interceptors.request.use((config) => {
  const session = readSession();
  if (session?.session_token) {
    config.headers.Authorization = `Bearer ${session.session_token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadSession = Boolean(localStorage.getItem("stagelink-user"));
      localStorage.removeItem("stagelink-user");
      if (hadSession) {
        window.location.assign("/");
      }
    }
    return Promise.reject(error);
  }
);

export const loadDashboard = async () => {
  const response = await api.get("/dashboard");
  return response.data;
};

export const login = async (payload) => {
  const response = await api.post("/auth/login", payload);
  return response.data;
};

export const logout = async () => {
  const response = await api.post("/auth/logout");
  return response.data;
};

export const getScanContext = async (token) => {
  const response = await api.get(`/scan/${token}`);
  return response.data;
};

export const confirmAttendance = async (payload) => {
  const response = await api.post("/attendance/confirm", payload);
  return response.data;
};

export const createStudent = async (payload) => {
  const response = await api.post("/students", payload);
  return response.data;
};

export const updateStudent = async (id, payload) => {
  const response = await api.patch(`/students/${id}`, payload);
  return response.data;
};

export const deleteStudent = async (id) => {
  const response = await api.delete(`/students/${id}`);
  return response.data;
};

export const createCompany = async (payload) => {
  const response = await api.post("/companies", payload);
  return response.data;
};

export const updateCompany = async (id, payload) => {
  const response = await api.patch(`/companies/${id}`, payload);
  return response.data;
};

export const deleteCompany = async (id) => {
  const response = await api.delete(`/companies/${id}`);
  return response.data;
};

export const createInternship = async (payload) => {
  const response = await api.post("/internships", payload);
  return response.data;
};

export const updateInternship = async (id, payload) => {
  const response = await api.patch(`/internships/${id}`, payload);
  return response.data;
};

export const deleteInternship = async (id) => {
  const response = await api.delete(`/internships/${id}`);
  return response.data;
};

export const importStudentsCsv = async (payload) => {
  const response = await api.post("/import/students-csv", payload);
  return response.data;
};

export const getEmailDetail = async (id) => {
  const response = await api.get(`/emails/${id}`);
  return response.data;
};

export const resendEmail = async (id) => {
  const response = await api.post(`/emails/${id}/resend`);
  return response.data;
};

export const listUsers = async () => {
  const response = await api.get("/users");
  return response.data;
};

export const createUser = async (payload) => {
  const response = await api.post("/users", payload);
  return response.data;
};

export const updateUser = async (id, payload) => {
  const response = await api.patch(`/users/${id}`, payload);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const getEtablissementSettings = async () => {
  const response = await api.get("/settings/etablissement");
  return response.data;
};

export const updateEtablissementSettings = async (payload) => {
  const response = await api.put("/settings/etablissement", payload);
  return response.data;
};